import { makeRPCClient } from "bunfx";
import type { RPC } from "./server/rpc/types";

export const rpc: RPC = makeRPCClient();
